(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jm_slideshow-heading"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shs-slideshow')) {
    class ShsSlideshow extends HTMLElement {
      connectedCallback() {
        if (this._ready) {
          this.startAutoplay();
          return;
        }

        this.track = this.querySelector('.shs__track');
        const real = Array.from(this.track.querySelectorAll('.shs-slide'));
        this.slides = real;
        this.count = real.length;
        this.index = 0;
        this.fade = this.dataset.transition === 'fade';

        if (this.fade) {
          this.classList.add('is-fade');
          if (!this.track.querySelector('.is-active') && real[0]) real[0].classList.add('is-active');
        }

        if (this.count < 2) {
          this.classList.add('is-single');
          return;
        }
        this._ready = true;

        if (!this.fade) {
          // Copies of the first and last slide make the loop seamless
          const firstCopy = real[0].cloneNode(true);
          const lastCopy = real[this.count - 1].cloneNode(true);
          [firstCopy, lastCopy].forEach((copy) => {
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
          });
          this.track.appendChild(firstCopy);
          this.track.insertBefore(lastCopy, this.track.firstChild);
        }

        const prev = this.querySelector('.shs__arrow--prev');
        const next = this.querySelector('.shs__arrow--next');
        if (prev) prev.addEventListener('click', () => this.step(-1));
        if (next) next.addEventListener('click', () => this.step(1));

        this.dotsWrap = this.querySelector('.shs__dots');
        if (this.dotsWrap) {
          this.dotsWrap.innerHTML = '';
          for (let i = 0; i < this.count; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'shs__dot';
            dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            dot.addEventListener('click', () => this.goToIndex(i));
            this.dotsWrap.appendChild(dot);
          }
        }

        if (this.fade) {
          // Swipe left or right on touch screens
          let startX = 0;
          this.track.addEventListener('touchstart', (e) => {
            startX = e.changedTouches[0].clientX;
          }, { passive: true });
          this.track.addEventListener('touchend', (e) => {
            const dx = e.changedTouches[0].clientX - startX;
            if (Math.abs(dx) > 40) this.step(dx < 0 ? 1 : -1);
          }, { passive: true });
        } else {
          this.jumpTo(1);

          let timer;
          this.track.addEventListener('scroll', () => {
            const pos = this.position();
            this.index = (((pos - 1) % this.count) + this.count) % this.count;
            this.updateDots();
            clearTimeout(timer);
            timer = setTimeout(() => this.settle(), 100);
          });

          let lastWidth = this.track.clientWidth;
          if (window.ResizeObserver) {
            this.resizeObserver = new ResizeObserver(() => {
              const w = this.track.clientWidth;
              if (w && w !== lastWidth) {
                lastWidth = w;
                this.jumpTo(this.index + 1);
              }
            });
            this.resizeObserver.observe(this.track);
          }
        }
        this.updateDots();

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !this.reduceMotion) {
          this.speed = parseInt(this.dataset.speed, 10) || 5000;
          this.startAutoplay(true);
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());
          this.addEventListener('focusin', () => this.stopAutoplay());
          this.addEventListener('focusout', () => this.startAutoplay());
          this.addEventListener('touchstart', () => this.stopAutoplay(), { passive: true });
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }

      width() {
        return this.track.clientWidth || 1;
      }

      position() {
        return Math.round(this.track.scrollLeft / this.width());
      }

      // Instant move with no animation (used for the silent loop jump)
      jumpTo(pos) {
        const t = this.track;
        t.style.scrollBehavior = 'auto';
        t.style.scrollSnapType = 'none';
        t.scrollLeft = pos * this.width();
        requestAnimationFrame(() => {
          t.style.scrollBehavior = '';
          t.style.scrollSnapType = '';
        });
      }

      // When we land on a copy, silently jump to the real slide
      settle() {
        const pos = this.position();
        if (pos === 0) this.jumpTo(this.count);
        else if (pos === this.count + 1) this.jumpTo(1);
      }

      // Fade mode: show one slide
      show(i) {
        this.index = ((i % this.count) + this.count) % this.count;
        this.slides.forEach((slide, n) => {
          slide.classList.toggle('is-active', n === this.index);
        });
        this.updateDots();
      }

      step(delta) {
        if (this.fade) {
          this.show(this.index + delta);
          return;
        }
        const target = Math.min(Math.max(this.position() + delta, 0), this.count + 1);
        this.track.scrollTo({ left: target * this.width(), behavior: 'auto' });
      }

      goToIndex(i) {
        if (this.fade) {
          this.show(i);
          return;
        }
        this.track.scrollTo({ left: (i + 1) * this.width(), behavior: 'auto' });
      }

      updateDots() {
        if (!this.dotsWrap) return;
        Array.from(this.dotsWrap.children).forEach((dot, i) => {
          dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        });
      }

      // On page load, count the first wait from when the page first appeared
      firstDelay() {
        const full = this.speed;
        if (performance.now() > 15000) return full;
        const paint = performance.getEntriesByName('first-contentful-paint')[0];
        const shownAt = paint ? paint.startTime : performance.now();
        const elapsed = Math.max(0, performance.now() - shownAt);
        return Math.max(800, full - elapsed);
      }

      startAutoplay(first) {
        this.stopAutoplay();
        if (!this.speed) return;
        const loop = () => {
          this.interval = setInterval(() => this.step(1), this.speed);
        };
        if (first) {
          this.timeout = setTimeout(() => {
            this.step(1);
            loop();
          }, this.firstDelay());
        } else {
          loop();
        }
      }

      stopAutoplay() {
        clearInterval(this.interval);
        clearTimeout(this.timeout);
      }
    }
    customElements.define('shs-slideshow', ShsSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jm_supplier-info"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sti-section')) {
    class StiSection extends HTMLElement {
      connectedCallback() {
        this.links = Array.from(this.querySelectorAll('.sti__link'));
        this.areas = this.links.map((link) => document.getElementById(link.getAttribute('href').slice(1)));
        this.list = this.querySelector('.sti__list');
        this.nav = this.querySelector('.sti__nav');
        this.active = -1;
        if (!this.links.length) return;

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Clicking a menu item scrolls to that part
        this.links.forEach((link, i) => {
          link.addEventListener('click', (e) => {
            const target = this.areas[i];
            if (!target) return;
            e.preventDefault();
            target.scrollIntoView({ behavior: this.reduceMotion ? 'auto' : 'smooth', block: 'start' });
            history.replaceState(null, '', link.getAttribute('href'));
            const heading = target.querySelector('.sti__heading');
            if (heading) heading.focus({ preventScroll: true });
            this.setActive(i);
          });
        });

        // Highlight the part being read
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.update();
          });
        };
        // Listen to scrolling anywhere, in case the theme scrolls a box instead of the window
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll);
        this.update();
        setTimeout(this.onScroll, 300);
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onScroll);
      }

      update() {
        // Mark the menu as stuck so the gap above it gets filled
        if (this.nav) {
          const top = parseFloat(getComputedStyle(this.nav).top) || 0;
          const stuck = this.nav.getBoundingClientRect().top <= top + 1 && this.getBoundingClientRect().top < top;
          this.nav.classList.toggle('is-stuck', stuck);
        }
        const first = this.areas[0];
        if (!first) return;
        const margin = parseFloat(getComputedStyle(first).scrollMarginTop) || 0;
        const vh = window.innerHeight;
        // A part becomes current once its top passes this line on the screen
        const line = Math.max(margin + 40, vh * 0.35);
        let current = 0;
        this.areas.forEach((area, i) => {
          if (area && area.getBoundingClientRect().top <= line) current = i;
        });
        // When the end of the section is on screen and the last part is in view, highlight it
        const last = this.areas[this.areas.length - 1];
        if (last && this.getBoundingClientRect().bottom <= vh && last.getBoundingClientRect().top <= vh * 0.6) {
          current = this.areas.length - 1;
        }
        this.setActive(current);
      }

      setActive(i) {
        if (this.active === i) return;
        this.active = i;
        this.links.forEach((link, n) => {
          link.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
        // On mobile, keep the active item visible in the menu bar
        if (this.list && this.list.scrollWidth > this.list.clientWidth) {
          const link = this.links[i];
          const left = link.offsetLeft - (this.list.clientWidth - link.offsetWidth) / 2;
          this.list.scrollTo({ left: left, behavior: this.reduceMotion ? 'auto' : 'smooth' });
        }
      }
    }
    customElements.define('sti-section', StiSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
